/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from "react";
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from "semantic-ui-react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { UniversalLink } from "@plone/volto/components";
import { useSelector } from "react-redux";
import { useGoogleAnalytics } from "volto-google-analytics";
import logo from "../../../../../theme/static/images/footer-logo.svg";
const messages = defineMessages({
  copyright: {
    id: "Copyright",
    defaultMessage: "Copyright",
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  const siteTitle = useSelector(
    (state) => state.site?.data?.["plone.site_title"],
  );
  return (
    <div className="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={4} textAlign="left" className="columnborder">
                <img class="footer-logo" src={logo} alt="Logo" />
                <p>
                  Enhancing governance through the application of the rule of
                  law.
                </p>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>Quick Links</List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about">About</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-work">Our work</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/our-people">
                        Our People
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/contact-us">
                        Contact us
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn
                width={1}
                textAlign="left"
                className="columnborder"
              ></GridColumn>
              <GridColumn width={5} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://www.linkedin.com/company/juizi-cc"
                            target="_blank"
                            title="LinkedIn"
                          >
                            <i className="bi bi-linkedin"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.facebook.com/juizi.web"
                            target="_blank"
                            title="Facebook"
                          >
                            <i className="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://bsky.app/profile/juizi-web.bsky.social"
                            target="_blank"
                            title="Bluesky"
                          >
                            <i className="bi bi-bluesky"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/@juiziweb"
                            target="_blank"
                            title="YouTube"
                          >
                            <i className="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://plone.social/@Juizi@mastodon.social"
                            target="_blank"
                            title="Mastodon"
                          >
                            <i className="bi bi-mastodon"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://x.com/juizi_web"
                            target="_blank"
                            title="X"
                          >
                            <i className="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <span className="footer-copyright">
                        <span title={intl.formatMessage(messages.copyright)}>
                          ©
                        </span>{" "}
                        {siteTitle} {new Date().getFullYear()}
                      </span>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of{" "}
                      <a href="https://www.pexels.com" target="_blank">
                        Pexels
                      </a>{" "}
                      &{" "}
                      <a href="https://unsplash.com" target="_blank">
                        Unsplash
                      </a>
                    </List.Item>
                    <List.Item className="footer-totop">
                      <UniversalLink
                        href="#top"
                        className="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-circle"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div className="belowFooter-container">
        <div className="belowFooter">
          <a href="https://juizi.com" target="_blank">
            <img src="https://juizi.com/juizi.png" />
          </a>
          <div className="belowFooter-links">
            <a href="/terms-conditions">Terms & Conditions</a>
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
